import React from "react";
import {Link} from "react-router-dom";

function Footer() {
    function hwpViewer() {
        alert('123');
    }

    return (
        <footer className="main-footer">
            <div className="footer-upper"></div>
            {/* <!--Footer Bottom--> */}
            <div className="footer-bottom">
                <div className="auto-container">
                    <div className="row clearfix" style={{display: 'flex'}}>
                        <div className="col-md-3 col-sm-3 col-xs-3">
                            <p>
                                <li style={{
                                    textAlign: "left",
                                    float: "left",
                                    lineHeight: '58px',
                                    WebkitAppearance: 'none',
                                    WebkitBorderRadius: '0'
                                }}>
                                    <img src="./images/home/logo3.png" alt=''/>
                                </li>
                            </p>
                        </div>
                        <div className="copyright-text">
                            <li>㈜넥스모어시스템즈 | 사업자등록번호 220-86-49824 | 대표자 김용걸</li>
                            <li>Tel. 02-556-3359 | 서울특별시 성동구 아차산로 103, 7층 708, 709호</li>
                            <li>COPYRIGHT© BY NEXMORESYSTEMS INC. ALL RIGHTS RESERVED</li>
                            <li className="info">
                                <a href="/images/service/1_넥스모어시스템즈_개인위치정보사업 이용약관.pdf">
                                    개인위치정보사업 이용약관
                                </a>
                                <a href="/images/service/2_넥스모어시스템즈_개인위치정보처리방침.pdf">
                                    개인위치정보 처리방침
                                </a>
                                <a href="/images/service/3_넥스모어시스템즈_개인위치정보관리지침.pdf">
                                    개인위치정보 관리지침
                                </a>
                                <a href="/images/service/2.개인정보처리방침_넥스모어시스템즈.pdf">
                                    개인정보 처리방침
                                </a>
                            </li>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
